import "./DashboardpagesCss/profilePage.css";
import { AiFillEdit } from "react-icons/ai";
import { useNavigate, useOutletContext } from "react-router-dom";
import { FaUserDoctor } from "react-icons/fa6";
import { useEffect, useState } from "react";
// import img1 from "../../Assets/Medical doctor_ 2.png";
import toast from "react-hot-toast";
import { getProfileStatus } from "../../api/api";
import {
  getUserData,
  getUserMobile,
  mergeAndSetUserData,
} from "../../utils/auth";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaEdit } from "react-icons/fa";
// import img1 from "../../Assets/doctorImg.webp";
import img1 from "../../Assets/doctorImg.webp";
import icon1 from "../../Assets/icon1.png";
import icon2 from "../../Assets/icon2.png";
import CustomLoader from "../../common/loader/CustomLoader";
const ProfilePage = () => {
  const { userData } = useOutletContext();
  const [profileData, setProfileData] = useState([]);
  const [patientDetails, setPatientDetails] = useState();

  const navigator = useNavigate();

  const handleEditProfile = (e) => {
    // e.preventDefault();
    navigator("/dashboard/edit-profile", { state: { profileData },from: "profile" });
  };

  const statusHandler = (status) => {
    switch (status.toLowerCase()) {
      case "pending":
        return "#F6A812";
      case "completed":
        return "green";
      case "cancelled":
      case "canceled": // handle both spellings
        return "red";
      default:
        return "gray"; // fallback color
    }
  };

  const appointmentData = [
    {
      drName: "Dr. Roy mukherjee",
      speciality: "Dermatologist",
      date: "12 Sep",
      time: "12:30 PM",
      status: "Pending",
    },
    {
      drName: "Dr. Smith",
      speciality: "Cardiologist",
      date: "15 Sep",
      time: "10:00 AM",
      status: "Completed",
    },
    {
      drName: "Dr. Sharma",
      speciality: "Orthopedic",
      date: "18 Sep",
      time: "02:15 PM",
      status: "Cancelled",
    },
    {
      drName: "Dr. Khan",
      speciality: "Pediatrician",
      date: "20 Sep",
      time: "11:45 AM",
      status: "Pending",
    },
    {
      drName: "Dr. Sen",
      speciality: "Neurologist",
      date: "22 Sep",
      time: "04:00 PM",
      status: "Completed",
    },
  ];

  const bestDoctorData = [
    {
      img: "https://static.vecteezy.com/system/resources/thumbnails/026/375/249/small_2x/ai-generative-portrait-of-confident-male-doctor-in-white-coat-and-stethoscope-standing-with-arms-crossed-and-looking-at-camera-photo.jpg",
      dName: "Soumik Mondal",
      dSpeciality: "Cardiologist",
      rating: 4.5,
    },
    {
      img: "https://static.vecteezy.com/system/resources/thumbnails/026/375/249/small_2x/ai-generative-portrait-of-confident-male-doctor-in-white-coat-and-stethoscope-standing-with-arms-crossed-and-looking-at-camera-photo.jpg",
      dName: "Ananya Sen",
      dSpeciality: "Dermatologist",
      rating: 4.7,
    },
    {
      img: "https://static.vecteezy.com/system/resources/thumbnails/026/375/249/small_2x/ai-generative-portrait-of-confident-male-doctor-in-white-coat-and-stethoscope-standing-with-arms-crossed-and-looking-at-camera-photo.jpg",
      dName: "Rajiv Sharma",
      dSpeciality: "Orthopedic Surgeon",
      rating: 4.6,
    },
    {
      img: "https://static.vecteezy.com/system/resources/previews/022/449/851/non_2x/ai-generated-portrait-of-a-smiling-female-doctor-free-photo.jpg",
      dName: "Priya Das",
      dSpeciality: "Pediatrician",
      rating: 4.8,
    },
    {
      img: "https://static.vecteezy.com/system/resources/previews/024/176/759/non_2x/ai-generated-portrait-of-a-male-doctor-free-photo.jpg",
      dName: "Arindam Chatterjee",
      dSpeciality: "Neurologist",
      rating: 4.9,
    },
  ];

  const paymentHistory = [
    {
      Date: "12 Sep 2025",
      Amount: "1,200",
      Service: "Dr. Roy (Dermatologist)",
      Status: "Pending",
      id: "TXN12345",
    },
    {
      Date: "15 Sep 2025",
      Amount: "900",
      Service: "Dr. Smith (Cardiologist)",
      Status: "Cancelled",
      id: "TXN12346",
    },
    {
      Date: "18 Sep 2025",
      Amount: "2,500",
      Service: "Health Checkup Package",
      Status: "Completed",
      id: "TXN12347",
    },
    {
      Date: "20 Sep 2025",
      Amount: "1,750",
      Service: "Dr. Mehta (Neurologist)",
      Status: "Completed",
      id: "TXN12348",
    },
    {
      Date: "22 Sep 2025",
      Amount: "600",
      Service: "Lab Test (Blood & Urine)",
      Status: "Completed",
      id: "TXN12349",
    },
    {
      Date: "18 Sep 2025",
      Amount: "2,500",
      Service: "Health Checkup Package",
      Status: "Completed",
      id: "TXN12347",
    },
    {
      Date: "20 Sep 2025",
      Amount: "1,750",
      Service: "Dr. Mehta (Neurologist)",
      Status: "Completed",
      id: "TXN12348",
    },
    {
      Date: "22 Sep 2025",
      Amount: "600",
      Service: "Lab Test (Blood & Urine)",
      Status: "Completed",
      id: "TXN12349",
    },
  ];

  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);

  // calculate pagination
  const totalPages = Math.ceil(paymentHistory.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = paymentHistory.slice(
    startIndex,
    startIndex + itemsPerPage
  );
  useEffect(() => {
    getProfileData();
  }, []);

  const [loading, setLoading] = useState(false);

  const getProfileData = async () => {
    try {
      // Retrieve user data using helper
      const user = getUserData();
      if (!user) {
        toast.error("No user data found. Redirecting to login...");
        navigator("/users/login");
        return;
      }

      const mobile = getUserMobile();

      // Prepare API payload
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        user_id: user?.user_id || "",
        mobile_no: "",
      };

      console.log("Profile check payload:", payload);

      // API call
      setLoading(true);
      const response = await getProfileStatus(payload);
      console.log("Profile Status Response:", response);

      if (response?.data?.status === "success") {
        const profileData = response.data.data || [];
        const firstProfile = Array.isArray(profileData)
          ? profileData[0]
          : profileData;
        setProfileData(profileData || {});
        setPatientDetails(firstProfile || {});

        // If API returned mobile_no, merge it into stored userData for global availability
        if (firstProfile && (firstProfile.mobile_no || firstProfile.mobile)) {
          mergeAndSetUserData(firstProfile);
        }
      } else {
        console.error("Profile fetch failed:", response?.data?.message);
        toast.error(response?.data?.message || "Unable to fetch profile data");
      }
    } catch (error) {
      console.error("Unexpected error fetching profile data:", error);
      toast.error("Something went wrong while loading your profile.");
    } finally {
      setLoading(false);
    }
  };

  return (
   
    <>
      {loading && <CustomLoader />}
  

    <div className="profile-dashboard">
      <div className="dashboard-header">
        <div>
          <h2>Welcome To,</h2>
          <h1>RB Diagnostic</h1>
          <p>Manage your account, see and edit your details below.</p>
        </div>
      </div>

      <div className="profile-card">
        <div className="profile-left">
          {/* <img
            src={img1}
            alt="Profile"
            className="profile-avatar"
          /> */}
          <div className="profile-avatar">
            {patientDetails?.PFirstName?.charAt(0).toUpperCase()}
          </div>

          <div className="profile-info">
            <div className="name-and-edit">
              <h2>
                {patientDetails?.PFirstName} {patientDetails?.PLastName}
              </h2>
              <button className="profile-edit-btn" onClick={handleEditProfile}>
                <FaEdit color="#0FB7A4" /> Edit Profile
              </button>
            </div>

            <p style={{ color: "#868686" }}>
              {patientDetails?.PSex === "F" ? "Female" : "Male"} |{" "}
              {patientDetails?.dateofbirth}
            </p>

            <div className="info-row">
              <FaPhoneAlt color="#0FB7A4" />{" "}
              <span>{patientDetails?.mobile_no}</span>
            </div>
            <div className="info-row">
              <FaEnvelope color="#0FB7A4" />{" "}
              <span>{patientDetails?.email}</span>
            </div>
           
            <div className="info-row">
              <FaMapMarkerAlt color="#0FB7A4" />
              <span>
                {patientDetails?.address} | {patientDetails?.Zipcode}
              </span>
            </div>
            { patientDetails?.landmark && (
             <div className="info-row">
              <FaMapMarkerAlt color="#0FB7A4" />
              <span> {patientDetails?.landmark}</span>
            </div>
            )}
          </div>
        </div>

        {/* <div className="quick-links">
          <h3>Appointment Quick Links</h3>

          <div className="quick-card blue">
            <div className="profile-icons">
              <img src={icon1} alt="home icon" />
            </div>
            <div>
              <h4 style={{ margin: "0" }}>Book Home Collection</h4>
              <p>Get appointment anytime</p>
            </div>
          </div>

          <div className="quick-card green">
            <div className="profile-icons">
              <img src={icon2} alt="home icon" />
            </div>
            <div>
              <h4>Book OPD Appointment</h4>
            </div>
          </div>
        </div> */}
      </div>
    </div>
    </>
  );
};

export default ProfilePage;
